var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.05 20.6111C16.07 21.5611 15 21.4111 13.97 20.9611C12.88 20.5011 11.88 20.4811 10.73 20.9611C9.29004 21.5811 8.53004 21.4011 7.67004 20.6111C2.79004 15.5811 3.51004 7.92105 9.05004 7.64105C10.4 7.71105 11.34 8.38105 12.13 8.44105C13.31 8.20105 14.44 7.51105 15.7 7.60105C17.21 7.72105 18.35 8.32105 19.1 9.40105C15.98 11.2711 16.72 15.3811 19.58 16.5311C19.01 18.0311 18.27 19.5211 17.04 20.6211L17.05 20.6111ZM12.03 7.58105C11.88 5.35105 13.69 3.51105 15.77 3.33105C16.06 5.91105 13.43 7.83105 12.03 7.58105Z",
    fill: "#131313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.34e2b333e2d0b501cfc34c3f56dffae0.svg";
export { ForwardRef as ReactComponent };